export const inspectTable = [
  {
    content: "유해ㆍ위험물질의 제조 등 금지 (법 제117조)",
    isChecked: "",
  },
  {
    content: "유해ㆍ위험물질의 제조 등 허가 (법 제118조)",
    isChecked: "",
  },
  {
    content: "유해인자 허용기준의 준수 (법 제107조)",
    isChecked: "",
  },
  {
    content: "화학물질의 유해성·위험성 조사 등 (법 제108조)",
    isChecked: "",
  },
];
